import { useQuery } from '@oneaudi/onegraph-client';
import type {
  CarlineStructureQuery,
  CarlineStructureQueryVariables,
} from '../../graphql/documents/carline-structure.generated';
import { CarlineStructureDocument } from '../../graphql/documents/carline-structure.generated';
import type { CarlineGroup } from '../../@types/mapped';

export const fetchCarlineGroups = (countryCode: string, language: string): CarlineGroup[] => {
  const { data } = useQuery<CarlineStructureQuery, CarlineStructureQueryVariables>(
    CarlineStructureDocument,
    {
      context: {
        consumerId: `${__FEATURE_APP_NAME__}@${__FEATURE_APP_VERSION__}`,
        headers: {
          'apollographql-client-name': __FEATURE_APP_NAME__,
          'apollographql-client-version': __FEATURE_APP_VERSION__,
        },
      },
      variables: {
        identifier: {
          brand: 'A',
          country: countryCode,
          language,
        },
      },
      errorPolicy: 'ignore',
    },
  );
  const carlineGroups = data?.carlineStructure.carlineGroups
    .map((carlineGroup: CarlineGroup) => {
      const filteredCarlines = carlineGroup.carlines.filter((carline) => carline.links);
      return {
        ...carlineGroup,
        carlines: filteredCarlines,
      };
    })
    .filter((carlinesGroup: CarlineGroup) => carlinesGroup.carlines.length !== 0);
  return carlineGroups || [];
};
